module.exports = __webpack_public_path__ + "img/tag-value-dark.e4e89b44.svg";